let i = 0

export const newId = () => {
  i += 1

  return `${i}-${Math.round(Math.random() * 100000)}`
}
